import React from 'react';
import { TextBlock } from 'common/ui/TextBlock';
import { LinearProgress, Stack, Typography } from '@mui/material';
import { usePlanMemberships } from 'modules/layout/hooks/usePlanMemberships';

type UsageBarProps = {
  title: string;
  subtitle: string;
  usage: number;
  limit: number;
};

const UsageBar: React.FC<UsageBarProps> = ({
  title,
  subtitle,
  usage,
  limit
}) => (
  <Stack direction="column" spacing="12px">
    <TextBlock variant="field" title={title} subtitle={subtitle} />
    <LinearProgress variant="determinate" value={(usage / limit) * 100} />
    <Typography
      sx={{
        alignSelf: 'flex-end',
        fontSize: '12px',
        lineHeight: '18px',
        color: 'customGrey.dark'
      }}
    >
      {usage}/{limit} used
    </Typography>
  </Stack>
);

type Props = {
  subtitle: string | React.ReactElement;
};

export const UsageField: React.FC<Props> = ({ subtitle }) => {
  const { scoreUsage, conversationUsage } = usePlanMemberships();

  return (
    <Stack direction="row" spacing="20px" sx={{ mb: '50px' }}>
      <TextBlock
        variant="section"
        title="Usage"
        subtitle={subtitle}
        sx={{
          width: '289px'
        }}
      />
      <Stack direction="column" flex={1} spacing="50px">
        {conversationUsage && (
          <UsageBar
            title="Conversations"
            subtitle={`${conversationUsage.messagesUsage} conversation credits used`}
            usage={conversationUsage.messagesUsage ?? 0}
            limit={conversationUsage.messagesLimit ?? 0}
          />
        )}
        {scoreUsage && (
          <UsageBar
            title="Applicants scored"
            subtitle={`${scoreUsage.scoringUsage} analysis credits used`}
            usage={scoreUsage.scoringUsage ?? 0}
            limit={scoreUsage.scoringLimit ?? 0}
          />
        )}
      </Stack>
    </Stack>
  );
};
